import { Habit, Task } from '@griply/types';
import { useMemo } from 'react';

export type UseHabitsInput = {
  tasks: Task[];
  undeletedOnly?: boolean;
};

export const useHabits = ({ tasks, undeletedOnly }: UseHabitsInput): Habit[] =>
  useMemo(
    () =>
      tasks.filter(
        ({ schedules, deletedAt }) =>
          !!schedules?.length && (!undeletedOnly || !deletedAt),
      ) as Habit[],
    [tasks, undeletedOnly],
  );
